import { shadowUp } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

export const drawerRoot = css`
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  background-color: var(${themeVariables.colors.surface.default});
  border-top-left-radius: var(${themeVariables.spacing.md});
  border-top-right-radius: var(${themeVariables.spacing.md});
  overflow: hidden;
`;

export const drawerHeader = css`
  flex-grow: 0;
`;

export const drawerBody = css`
  flex-grow: 1;
  overflow-y: auto;
  padding: var(${themeVariables.spacing.md}) var(${themeVariables.spacing.md}) 0;
`;

export const drawerFooter = css`
  flex-grow: 0;
  padding: var(${themeVariables.spacing.lg}) var(${themeVariables.spacing.md});
  ${shadowUp};
`;
